/**
 * Lit Legion types for client-side use.
 *
 * Local mirror of canonical types from @fias/db-types — the client package
 * cannot directly import from @fias/db-types. The architecture test
 * `tests/architecture/lit-legion-status-sync.test.ts` enforces that this
 * array stays in sync with VALID_LL_TASK_STATUSES in db-types.
 */

export const LL_TASK_STATUSES = [
  'available',
  'unavailable',
  'waiting',
  'expired',
  'accepted',
  'completed',
  'pending',
  'awarded',
] as const;

export type LLTaskStatus = (typeof LL_TASK_STATUSES)[number];

export function isLLTaskStatus(value: string): value is LLTaskStatus {
  return (LL_TASK_STATUSES as readonly string[]).includes(value);
}
